import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types';
import { transparentize, darken } from 'polished'

import './CustomButton.css';

const ButtonContainer = styled.div`
  width: ${({ size, width }) => {
    if(width) return width;
    switch (size) {
      case 'small': return '8em'
      case 'medium': return '11em'
      case 'large': return '17em'
      default: return '11em'
    }
  }};
  background: ${props => props.filled ? props.color : '#fff'};
  /* color: ${props => props.filled ? (props.disabled ? '#BDBDBD' : '#fff') : props.color}; */
  color: ${props => false ? '#BDBDBD' : (props.filled ? '#fff' : props.color)};
  border: ${props => props.filled ? 'none' : (false ? `2px solid #BDBDBD` : `2px solid ${props.color}`)};
  margin: ${props => props.margin ? props.margin : '0 30px'};
  padding: ${props => props.padding ? props.padding : '0 30px;'};
  /* opacity: ${props => props.disabled ? .3 : 1}; */
  cursor: ${props => props.disabled ? 'auto !important' : 'pointer'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  font-family: OpenSansBold;
  letter-spacing: 0.1em;
  font-size: 14px;
  text-transform: uppercase;
  opacity: ${props => props.disabled ? 0.4 : 1};
  &:hover {
    background: ${props => props.disabled ? (props.filled ? props.color : '#fff') : (props.filled ? darken(0.1, props.color) : transparentize(0.8, props.color))}
  }
  span {
    color: ${props => props.filled ? '#fff' : props.color};
    margin-left: 10px;
  }
  @media screen and (max-width: 364px){
    width: 10em
  }
  @media screen and (max-width: 320px){
    width: 9em
  }
`

export const CustomButton = ({ filled = false, color = '#9240c9', cancel, children, disabled, onClick, size, ...rest }) => {
  return (
    <ButtonContainer
      size={size}
      filled={filled}
      color={cancel ? '#FF6868' : color}
      disabled={disabled}
      className='custom_button'
      onClick={disabled ? null : onClick}
      {...rest}>
      {children}
    </ButtonContainer>
  )
}

CustomButton.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func
}

export default CustomButton
